/**
 * Validates latitude and longitude coordinates.
 *
 * @param lat - The latitude value to validate.
 * @param lng - The longitude value to validate.
 * @returns True if both latitude and longitude are valid, false otherwise.
 */
export function isValidCoordinates(lat: number, lng: number): boolean {
  if (isNaN(lat) || isNaN(lng)) {
    return false;
  }

  if (lat < -90 || lat > 90) {
    return false;
  }

  if (lng < -180 || lng > 180) {
    return false;
  }

  return true;
}
